// Work Context panel — shows the KaziPeople record this browser session is connected
// to, and a clear way back. It is a REFERENCE: labels only, no copied domain data.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Link as LinkIcon } from 'lucide-react';
import { Button } from '@/features/shared/components/ui/button';
import type { WorkContext } from '../lib/types';

const LABELS: Record<string, string> = {
  work_item: 'Work item', assignment: 'Assignment', project: 'Project', goal: 'Goal',
  recognition: 'Recognition', meeting: 'Meeting', leave: 'Leave', expense: 'Expense',
  survey: 'Survey', conversation: 'Conversation', payroll_run: 'Payroll run',
  employee: 'Employee', support_case: 'Support case', report: 'Report', document: 'Document',
};

export const WebContextPanel: React.FC<{ context: WorkContext }> = ({ context }) => {
  const navigate = useNavigate();
  const label = LABELS[context.type] ?? context.type;
  return (
    <aside className="rounded-xl border border-border bg-card p-4">
      <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        <LinkIcon className="h-3.5 w-3.5" /> Connected work
      </div>
      <div className="mt-2 text-sm font-semibold text-foreground">{context.title ?? label}</div>
      <div className="mt-0.5 text-xs text-muted-foreground">{label}</div>
      {context.sourceRoute && (
        <Button
          size="sm"
          variant="outline"
          className="mt-4 w-full"
          onClick={() => navigate(context.sourceRoute!)}
        >
          <ArrowLeft className="mr-1.5 h-4 w-4" /> Return to {label.toLowerCase()}
        </Button>
      )}
    </aside>
  );
};
